import React, { useCallback, useMemo, useState } from "react";

export const RowHeightContext = React.createContext<
  ((rowIndex: number, height: number) => void) | null
>(null);

// Permet de récupérer la hauteur maximum parmis n hauteurs stockées
export function useRowMaxHeight() {
  const [heights, setHeights] = useState<Map<number, number>>(new Map());

  const registerHeight = useCallback((rowIndex: number, height: number) => {
    setHeights((prev) => {
      if ((prev.get(rowIndex) ?? 0) >= height) return prev;
      const next = new Map(prev);
      next.set(rowIndex, height);
      return next;
    });
  }, []);

  const maxHeight = useMemo(
    () => (heights.size === 0 ? 0 : Math.max(...heights.values())),
    [heights],
  );

  return { registerHeight, maxHeight };
}
